



































import { Component, Emit, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { Paging } from '@/store/models';

@Component({
  name: 'VPaginationBar'
})
export default class VPaginationBar extends Mixin {
  @Prop({ required: true }) pagination?: Paging;

  get currentPage() {
    if (this.pagination && this.pagination.total && this.pagination.offset) {
      return Math.floor(this.pagination?.offset / this.pagination.limit) + 1;
    }
    return 1;
  }

  get totalPage() {
    if (this.pagination) {
      return (
        Math.floor(this.pagination?.total / this.pagination?.limit) +
        (this.pagination.total / this.pagination.limit > 0 ? 1 : 0)
      );
    }
    return -1;
  }

  public getFromToPage(): { from: number; to: number } {
    const numOfPreviewPages = 2;
    let from = 1;
    let to = 1;
    if (this.pagination) {
      for (let i = 1; i <= this.totalPage; i++) {
        if (this.currentPage - from > numOfPreviewPages) {
          from = i;
          to = from;
        }
        if (to - this.currentPage < numOfPreviewPages) {
          to = i;
        }
        if (this.currentPage < numOfPreviewPages) {
          to = from + Math.min(numOfPreviewPages * 2, this.totalPage);
        }
        if (this.currentPage > this.totalPage - numOfPreviewPages) {
          from = Math.max(this.totalPage - 2 * numOfPreviewPages, 1);
        }
      }
    }
    if (to > this.totalPage) to = this.totalPage;
    return { from, to };
  }

  get buildPaginationList() {
    const { from, to } = this.getFromToPage();
    const list: number[] = [];
    for (let i = from; i <= to; i++) {
      list.push(i);
    }
    return list;
  }
}
